/* TPL 2026-07-10 (audit P0-2) — visibility-gated PDP video playback.
 *
 * Product videos no longer carry the autoplay attribute (it forced full
 * downloads of every gallery + hidden-modal video on page load). Instead:
 *   - play muted/looped when ≥25% visible (gallery slide or opened lightbox)
 *   - pause when scrolled away or the lightbox closes
 *   - prefers-reduced-motion users keep the poster; playback stays manual
 *   - browsers without IntersectionObserver keep the poster (modal has controls)
 */
(function () {
  /* Run once even if two sections include this script (idempotent include). */
  if (window.__tplVideoLazyInit) return;
  window.__tplVideoLazyInit = true;
  /* Perf 2026-09-11: lightbox videos ship without poster= (see
     snippets/product-media.liquid). Put the poster on when the lightbox is
     opened so reduced-motion and autoplay-blocked visitors still see a frame. */
  function hydratePosters() {
    var vids = document.querySelectorAll('video[data-tpl-poster]');
    for (var i = 0; i < vids.length; i++) {
      vids[i].setAttribute('poster', vids[i].getAttribute('data-tpl-poster'));
      vids[i].removeAttribute('data-tpl-poster');
    }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target && e.target.closest && e.target.closest('modal-opener, .product__modal-opener, [data-tpl-open-lightbox]');
    if (opener) hydratePosters();
  }, true);

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var videos = document.querySelectorAll('.tpl-pdp-video video, [data-tpl-lazy-video]');
  if (!videos.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.hasAttribute('data-tpl-poster')) hydratePosters();
          /* iOS Safari needs these set as properties before play() */
          v.muted = true;
          v.defaultMuted = true;
          v.playsInline = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* autoplay blocked; poster stays */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach(function (v) { io.observe(v); });
})();
